import { useQuery } from "react-query";
import DashboardApiClient from "api/DashboardApiClient";

export function useSchools(regionId, sportTypeId) {
    return useQuery(["schools", { regionId, sportTypeId }], () =>
        DashboardApiClient.getSchoolsFromRegion(regionId, sportTypeId),
    );
}
